module.exports = "/img/plugin.5d1edf4b.png";